/* eslint-disable import/prefer-default-export */
import { API_URL } from '../../../../../../utils/config';

export const FETCH_RADIOS_TO_BE_CLEANED_URL = `${API_URL}/retrievals/search/1`;
